import { defineSlotRecipe } from '@chakra-ui/react';

export const segmentedControlSlotRecipe = defineSlotRecipe({
  slots: ['track', 'thumb', 'item'],
  base: {
    track: {
      bg: 'bgElevated',
      borderRadius: 'full',
      p: '2px',
    },
    thumb: {
      borderRadius: 'full',
      bg: 'surface',
      boxShadow: '0 1px 2px rgba(0,0,0,0.35), inset 0 0.5px 0 rgba(255,255,255,0.14)',
    },
    item: {
      borderRadius: 'full',
      bg: 'transparent',
      fontWeight: 'semibold',
      lineHeight: '1',
      _focusVisible: {
        outline: '2px solid var(--chakra-colors-accent)',
        outlineOffset: '2px',
      },
    },
  },
  variants: {
    size: {
      small: {
        track: {},
        item: { h: '28px', fontSize: '12px', px: 2 },
      },
      medium: {
        track: {},
        item: { h: '32px', fontSize: '13px', px: 3 },
      },
      large: {
        track: {},
        item: { h: '44px', fontSize: '13px', px: 2 },
      },
    },
    selected: {
      true: { item: { color: 'text' } },
      false: { item: { color: 'textMuted' } },
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});
